import { DEFAULT_LANGUAGE } from '@/constant/Languages/language';
import * as Yup from 'yup';

/**
 * Generate a localizations schema with conditional validation.
 *
 * @param {Array<string>} localeCodes - List of locale codes.
 * @returns {Yup.ObjectSchema} - The generated Yup schema.
 */
const createLocalizationsSchema = (localeCodes) => {
  return Yup.object(
    localeCodes.reduce((acc, localeCode) => {
      acc[localeCode] = Yup.string()
        .label(`Name (${localeCode.toUpperCase()})`)
        .max(255)
        .when([], {
          is: () => localeCode === DEFAULT_LANGUAGE,
          then: (schema) => schema.required(),
          otherwise: (schema) => schema.nullable(),
        });
      return acc;
    }, {})
  );
};

export default createLocalizationsSchema;
